export const getFileExtension = (url: string): string => {
    if (url !== '') {
        return /[^.]+$/.exec(url)?.[0] || ''
    }
    return ''
}
